import ParticlesConfig from "./ParticlesConfig";
import React from "react";

import Particles from "react-particles-js";
const ParticlesBackground = () => {

    return (

        <Particles params={ParticlesConfig}></Particles>


    )
}

export default ParticlesBackground ; 